<template>
  <div class="cauchy-pro-fixed">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$|u·v| ≤ |u||v|$</div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage dark-stage">
        <div class="hud-panel">
          <div class="hud-item cyan">
             <label>点积积值 |u·v|</label>
             <span class="val">{{ dotProduct.toFixed(2) }}</span>
          </div>
          <div class="hud-item orange">
             <label>模长乘积 |u||v|</label>
             <span class="val">{{ magProduct.toFixed(2) }}</span>
          </div>
          <div class="hud-item blue">
             <label>比值 cosθ</label>
             <span class="val">{{ (dotProduct / magProduct).toFixed(4) }}</span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 450 240" preserveAspectRatio="xMidYMid meet">
          <g transform="translate(225, 120)">
             <!-- 坐标参考 -->
             <line x1="-120" y1="0" x2="120" y2="0" stroke="#334155" stroke-dasharray="2,2" />
             <line x1="0" y1="-100" x2="0" y2="100" stroke="#334155" stroke-dasharray="2,2" />

             <!-- 向量 u(u1, u2) -->
             <line x1="0" y1="0" :x2="u1*1.5" :y2="-u2*1.5" stroke="#f43f5e" stroke-width="4" marker-end="url(#arr-u)" />
             <text :x="u1*1.5" :y="-u2*1.5-10" text-anchor="middle" fill="#f43f5e" font-size="10" font-weight="900">u({{u1}}, {{u2}})</text>
             
             <!-- 向量 v (固定轴或动态 V) -->
             <line x1="0" y1="0" :x2="v1*1.5" :y2="-v2*1.5" stroke="#0ea5e9" stroke-width="4" marker-end="url(#arr-v)" />
             <text :x="v1*1.5" :y="-v2*1.5+20" text-anchor="middle" fill="#0ea5e9" font-size="10" font-weight="900">v({{v1}}, {{v2}})</text>

             <!-- 投影示意 -->
             <circle r="40" fill="none" stroke="#334155" stroke-dasharray="4,2" />
          </g>
          <defs>
             <marker id="arr-u" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto"><path d="M0,0 L6,3 L0,6 Z" fill="#f43f5e" /></marker>
             <marker id="arr-v" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto"><path d="M0,0 L6,3 L0,6 Z" fill="#0ea5e9" /></marker>
          </defs>
        </svg>
        <div class="physics-caption">结论：两个向量的数量积(点积) 永不大于 其模长的乘积。</div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="flex-row gap-6">
              <div class="flex-1">
                 <label class="s-label">向量 u1 分量 (X轴)</label>
                 <el-slider v-model="u1" :min="-80" :max="80" size="small"></el-slider>
              </div>
              <div class="flex-1">
                 <label class="s-label">向量 u2 分量 (Y轴)</label>
                 <el-slider v-model="u2" :min="-80" :max="80" size="small"></el-slider>
              </div>
              <div class="flex-1">
                 <label class="s-label">调节向量 v 的基底</label>
                 <el-slider v-model="v1" :min="10" :max="80" size="small"></el-slider>
              </div>
           </div>
        </div>
        <div class="discovery-card-discovery-tir" v-latex>
           <i class="el-icon-aim"></i>
           <p><strong>实战物理/数学：</strong>柯西不等式是向量投影的基础。<strong>观察：</strong>点击滑块旋转向量 $u$，你会发现无论它指向哪里，其长度乘积（最强能量）永远覆盖了其投影点积。<strong>物理应用：</strong>在量子力学中，这正是海森堡不确定性原理的数学底座。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'CauchyInequalityViz',
  data() { return { u1: 60, u2: 40, v1: 70, v2: 0 } },
  computed: {
    dotProduct() { return Math.abs(this.u1 * this.v1 + this.u2 * this.v2); },
    magProduct() { 
       return Math.sqrt(this.u1 * this.u1 + this.u2 * this.u2) * Math.sqrt(this.v1 * this.v1 + this.v2 * this.v2); 
    }
  }
}
</script>

<style scoped lang="scss">
@import "./InequalityStyle.scss";
.cauchy-pro-fixed { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
</style>
